import $ from "jquery";

/*------------------------------------*\
    BABEL POLYFILL
\*------------------------------------*/
import "babel-polyfill";

/*------------------------------------*\
    BOOTSTRAP MODULES
\*------------------------------------*/
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/modal';

/*------------------------------------*\
    MODULES
\*------------------------------------*/
import GoogleMap from './modules/google-map';
import ImageGallery from './modules/image-gallery';
import Lazyload from './modules/lazyload';
import Lot from './modules/lot';
import MobileCollapse from './modules/mobile-collapse';
import PickANom from './modules/pick-a-nom';
import Scroller from './modules/scroller';
import SiteNav from './modules/site-nav';
import TypeMate from 'typemate';
import VimeoProfileVideo from './modules/profile-vimeo-video-autoplay';
import YoutubeProfileVideo from './modules/profile-youtube-video-autoplay';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();

        if (window.location.href === 'https://www.chapelstud.co.uk/our-stallions/planteur#stallion-gallery') {
            $('#video-tab').tab('show');
            document.getElementById('stallion-gallery').scrollIntoView({ block: 'start',  behavior: 'smooth' });
        }
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module) {

                    case 'google-map':

                        let googleMapInstance = new GoogleMap(item);

                        googleMapInstance.init();

                        break;

                    case 'image-gallery':

                        let imageGalleryInstance = new ImageGallery(item);

                        imageGalleryInstance.init();

                        break;

                    case 'lot':

                        let lotInstance = new Lot(item);

                        lotInstance.init();

                        break;

                    case 'mobile-collapse':

                        let mobileCollapseInstance = new MobileCollapse(item);

                        mobileCollapseInstance.init();

                        break;

                    case 'scroller':

                        let scrollerInstance = new Scroller(item);

                        scrollerInstance.init();

                        break;

                    case 'site-nav':

                        let siteNavInstance = new SiteNav(item);

                        siteNavInstance.init();

                        break;

                    case 'profile-vimeo-video-autoplay':

                        let profileVimeoVideoInstance = new VimeoProfileVideo(item);

                        profileVimeoVideoInstance.init();

                        break;

                    case 'profile-youtube-video-autoplay':

                        let profileYoutubeVideoInstance = new YoutubeProfileVideo(item);

                        profileYoutubeVideoInstance.init();

                        break;

                    case 'pick-a-nom':

                        let pickANom = new PickANom(item);

                        pickANom.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        console.log('alwaysload');

        const typeMateInstance = new TypeMate(document.querySelector('body'), {
            selector: 'p, h1, h2, h3'
        });
        typeMateInstance.apply();

        let lazyloadInstance = new Lazyload();
        lazyloadInstance.init();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();